<template>
  <div>
    <v-row>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="mr-1">date_range</v-icon>
        </template>
        <span>Working Product Year</span>
      </v-tooltip>
      <v-select dense hide-details :items="items" v-model="year" style="max-width: 80px" />
    </v-row>
  </div>
</template>

<script>
import { getProductRateYearList } from "@/config/productRateYears";

export default {
  data() {
    return {
      items: getProductRateYearList(),
    };
  },
  computed: {
    year: {
      get() {
        return this.$store.getters["workingYear"];
      },
      set(value) {
        this.$store.dispatch("setDefaultProductYear", value);
      },
    },
  },
};
</script>
